import { COLORS } from "../../common/constants";

export const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 20px 15px 15px",
    backgroundColor: COLORS.lightBlue,
    width: "calc(100% - 30px)",
    position: "fixed",
    top: 0,
    height: "45px",
    zIndex: 99,
    backdropFilter: "blur(8px)",
    boxShadow: "0 0 9px rgba(0, 0, 0, 0.09)",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  entityName: {
    color: COLORS.primary,
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 900,
  },
  search: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 14px",
    },
  },
  notification: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "10px",
    "& img": {
      width: "40px",
      height: "40px",
    },
  },
  userContainer: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    height: "45px",
    padding: "0 15px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
      "& .MuiSvgIcon-root": {
        transform: "scale(1.1)",
      },
    },
    "& .MuiSvgIcon-root": {
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "& p": {
      transition: "color 0.3s ease",
    },
  },
  role: {
    color: "#6b7280",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 900,
  },
  name: {
    color: COLORS.black,
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: 900,
  },
  picture: {
    width: "32px",
    height: "32px",
    color: "#94a3b8",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  dropdownIcon: {
    fontSize: "20px",
    color: COLORS.primary,
  },
  menuPaper: {
    borderRadius: "12px",
    marginTop: "8px",
    minWidth: "200px",
    boxShadow:
      "0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 8px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${COLORS.borderColor}`,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "3px",
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, #0066b3 100%)`,
    },
  },
  menuList: {
    padding: "8px 0",
  },
  menuItem: {
    padding: "4px 16px 4px 8px",
    margin: "0 4px",
    borderRadius: "8px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: COLORS.selectedCard,
      "& .menu-icon-wrapper": {
        backgroundColor: `${COLORS.primary}15`,
        transform: "scale(1.05)",
      },
      "& .MuiSvgIcon-root": {
        color: COLORS.primary,
        transform: "scale(1.1)",
      },
    },
    "&:active": {
      backgroundColor: COLORS.borderColor,
      transform: "scale(0.98)",
    },
  },
  logoutMenuItem: {
    "&:hover": {
      backgroundColor: "#fff5f5",
      "& .MuiTypography-root": {
        color: COLORS.secondary,
      },
      "& .menu-icon-wrapper": {
        backgroundColor: `${COLORS.secondary}15`,
        transform: "scale(1.05)",
      },
      "& .MuiSvgIcon-root": {
        color: COLORS.secondary,
        transform: "scale(1.1)",
      },
    },
  },
  menuItemContent: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "12px",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    backgroundColor: `${COLORS.primary}08`,
    transition: "all 0.2s ease-in-out",
    flexShrink: 0,
  },
  logoutIconWrapper: {
    backgroundColor: `${COLORS.secondary}08`,
  },
  menuIcon: {
    fontSize: "18px",
    color: COLORS.primary,
    transition: "all 0.2s ease-in-out",
  },
  menuItemText: {
    fontSize: "14px",
    fontWeight: 500,
    color: COLORS.black,
    letterSpacing: "0.01em",
    transition: "all 0.2s ease-in-out",
  },
  logoutText: {
    color: COLORS.black,
  },
  menuDivider: {
    margin: "4px 8px",
    backgroundColor: COLORS.borderColor,
  },
};
